import { createAsyncThunk } from "@reduxjs/toolkit";
import { getCustomersBalance } from "../../services/accounts";
import {
  getCustomersList,
  getCustomersCode,
  getEmployees,
  getLocations,
  getCustomersGroup,
  saveCustomers,
} from "../../services/customer";
import {
  getCustomerListGroupApi,
  updateCustomerListGroupApi,
  deleteCustomerGroupApi,
} from "../../apiservice/sales";
import { deleteAccountApi } from "../../apiservice/accounts";
// fecth Customer credit limit and due balance

export const fetchCustomersBalance = createAsyncThunk(
  "customers/fetchCustomersBalance",
  async (id, { rejectWithValue }) => {
    try {
      const response = await getCustomersBalance(id);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const fetchCustomersList = createAsyncThunk(
  "customers/fetchCustomersList",
  async (_, { rejectWithValue }) => {
    try {
      const payload = {
        acc_type_name: "Customer",
      };
      const response = await getCustomersList(payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);
export const fetchCustomersGroupList = createAsyncThunk(
  "customers/fetchCustomersGroupList",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getCustomersGroup();
      return response.data || [];
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const fetchGroupCustomers = createAsyncThunk(
  "customers/fetchGroupCustomers",
  async (id, { rejectWithValue }) => {
    try {
      const body = {
        customer_group_id: id,
      };
      const response = await getCustomerListGroupApi(body);
      return response.data || [];
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const updateCustomerListGroup = createAsyncThunk(
  "customers/updateCustomerListGroup",
  async (payload, { rejectWithValue }) => {
    try {
      const body = {
        acc_id: payload.acc_id,
        customer_group_id: payload.customer_group_id,
      };
      const response = await updateCustomerListGroupApi(body);
      return response.data || [];
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const deleteCustomerGroup = createAsyncThunk(
  "customers/deleteCustomerGroup",
  async (payload, { rejectWithValue }) => {
    try {
      const body = {
        id: payload.id,
      };
      const response = await deleteCustomerGroupApi(body);
      return response.data || [];
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const deleteCustomer = createAsyncThunk(
  "customers/deleteCustomer",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await deleteAccountApi(payload);
      return response.data || [];
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const fetchCustomersDetails = createAsyncThunk(
  "customers/fetchCustomersDetails",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getCustomersCode();
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);
export const fetchCustomersCode = createAsyncThunk(
  "customers/fetchCustomersCode",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getCustomersCode();
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const fetchLocations = createAsyncThunk(
  "customers/fetchLocations",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getLocations();
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const fetchEmployees = createAsyncThunk(
  "customers/fetchEmployees",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getEmployees();
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const createCustomer = createAsyncThunk(
  "customers/createCustomer",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await saveCustomers(payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);
